module.exports = __webpack_public_path__ + "img/profile_todolist.f1d1f469.png";